import {
  DataService,
  GetProductVariantDocument,
  I18nService,
  ModalService,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { UpdateSkuDialogComponent } from "../../update-sku-dialog/update-sku-dialog.component";
import { take } from "rxjs";
import {
  DeletePackageReviewOrderLineDocument,
  GetProductVariantPackageReviewDocument,
  UpdatePackageReviewOrderLineDocument,
} from "src/generated-gql/graphql";
import { marker as _ } from "@biesbjerg/ngx-translate-extract-marker";

@Component({
  selector: "package-review-summary-expand-content",
  standalone: true,
  templateUrl: "./content.component.html",
  styleUrls: ["./content.component.scss"],
  imports: [SharedModule],
})
export default class PackageReviewSummaryExpandContent implements OnInit{
  @Input() item: {
    orderId: string;
    order: {
      code: string;
      orderId: string;
      x;
    };
    variants: any[];
  };
  @Input() index: number;

  constructor(
    protected translateService: I18nService
  ) {}
  ngOnInit(): void {
   console.log(this.item.variants);
   
  }
}
